'use client'

import { SessionProvider } from 'next-auth/react'
import { ThemeProvider } from 'next-themes'
import { usePathname } from 'next/navigation'

/*
 * Nothing here renews the session, and nothing here polls.
 *
 *   refetchInterval={0}          no background renewal — a poll is not a person
 *   refetchOnWindowFocus={false} alt-tabbing past a window is not using it
 *
 * Renewal happens server-side in `middleware.ts`, on navigations and saves. It used to happen here,
 * via a timer that called `update()`; that re-rendered every `useSession` consumer once a minute
 * and emptied any form somebody was in the middle of filling in. See lib/auth/session-activity.ts.
 */
export function Providers({ children }: { children: React.ReactNode }) {
  // The customer's onboarding page (/onboard/...) has no login. The session provider would fetch a session for it and leave sign-in cookies and a
  // localStorage entry in a customer's browser, and the admin theme switch does not apply: that page brings its own light, Charleston-branded look.
  const pathname = usePathname()
  if (pathname === '/onboard' || pathname?.startsWith('/onboard/')) return <>{children}</>
  return (
    <SessionProvider refetchInterval={0} refetchOnWindowFocus={false}>
      <ThemeProvider attribute="data-theme" defaultTheme="dark" enableSystem={false}>
        {children}
      </ThemeProvider>
    </SessionProvider>
  )
}
